export default __webpack_public_path__ + "static/media/calendar_today_green.80434895.svg";